module.exports = __webpack_public_path__ + "img/bus.c99ef73c.png";